import clsx from "clsx";
import { HiOutlineCheck, HiXMark } from "react-icons/hi2";

import FeaturedIcon, { FeaturedIconProps } from "@/components/atoms/FeaturedIcon";

type AlertProps = {
  heading: string;
  onClose?: () => void;
  isCloseable?: boolean;
  isVisible?: boolean;
  featuredIcon?: {
    icon: FeaturedIconProps["icon"];
    color?: FeaturedIconProps["color"];
  };
  children?: React.ReactNode;
};

const Toast = ({ featuredIcon, heading, isVisible, onClose, isCloseable = true, children }: AlertProps) => {
  return (
    <div
      className={clsx(
        "pointer-events-auto relative flex w-full max-w-xl items-center justify-center gap-x-1 rounded-lg border border-secondary bg-white py-3 pl-6 pr-3 font-medium shadow-md",
        isVisible ? "animate-enter" : "animate-leave",
      )}
    >
      <div className="flex-1">
        <div className={clsx("flex items-center gap-3")}>
          <FeaturedIcon icon={featuredIcon?.icon || HiOutlineCheck} color={featuredIcon?.color} size={"sm"} />
          <div className={"flex flex-1 items-center gap-1.5"}>
            <p className="break-all text-sm font-medium text-secondary">{heading}</p>
            {children && <div>{children}</div>}
          </div>
        </div>
      </div>
      {isCloseable && (
        <div className={"absolute right-6 top-4.5"}>
          <button
            onClick={onClose}
            className="text-fg-senary focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-input"
          >
            <div className={"-m-3 p-3"}>
              <HiXMark className="h-5 w-5" aria-hidden="true" />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default Toast;
